// import React, { useRef, useState } from "react";

// const CalculatorPopup = ({ onClose }) => {
//     const [input, setInput] = useState("");
//     const [position, setPosition] = useState({ x: 100, y: 100 });
//     const [dragging, setDragging] = useState(false);
//     const offset = useRef({ x: 0, y: 0 });

//     const handleClick = (value) => setInput((prev) => prev + value);

//     const handleCalculate = () => {
//         try {
//             // eslint-disable-next-line no-eval
//             setInput(eval(input).toString()); // ⚠️ demo only
//         } catch {
//             setInput("Error");
//         }
//     };

//     const handleClear = () => setInput("");

//     // ✅ Allow typing in input
//     const handleChange = (e) => setInput(e.target.value);

//     // ✅ Handle Enter key press
//     const handleKeyDown = (e) => {
//         if (e.key === "Enter") handleCalculate();
//     };

//     // Dragging logic
//     const handleMouseDown = (e) => {
//         setDragging(true);
//         offset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//     };

//     const handleMouseMove = (e) => {
//         if (dragging) {
//             setPosition({
//                 x: e.clientX - offset.current.x,
//                 y: e.clientY - offset.current.y,
//             });
//         }
//     };

//     const handleMouseUp = () => setDragging(false);

//     return (
//         <div
//             style={{
//                 position: "fixed",
//                 top: position.y,
//                 left: position.x,
//                 background: "#fff",
//                 borderRadius: "12px",
//                 boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
//                 width: "260px",
//                 zIndex: 9999,
//                 userSelect: "none",
//             }}
//             onMouseMove={handleMouseMove}
//             onMouseUp={handleMouseUp}
//         >
//             {/* Drag Header */}
//             <div
//                 style={{
//                     background: "#0077ff",
//                     color: "#fff",
//                     padding: "8px 12px",
//                     borderTopLeftRadius: "12px",
//                     borderTopRightRadius: "12px",
//                     cursor: "move",
//                     display: "flex",
//                     justifyContent: "space-between",
//                 }}
//                 onMouseDown={handleMouseDown}
//             >
//                 <span>Calculator</span>
//                 <button
//                     onClick={onClose}
//                     style={{
//                         background: "transparent",
//                         border: "none",
//                         color: "#fff",
//                         fontSize: "16px",
//                         cursor: "pointer",
//                     }}
//                 >
//                     ✖
//                 </button>
//             </div>

//             {/* ✅ Editable Input */}
//             <input
//                 type="text"
//                 value={input}
//                 onChange={handleChange}
//                 onKeyDown={handleKeyDown}
//                 style={{
//                     width: "100%",
//                     padding: "10px",
//                     fontSize: "18px",
//                     textAlign: "right",
//                     border: "none",
//                     borderBottom: "1px solid #ddd",
//                     outline: "none",
//                 }}
//             />

//             {/* Buttons */}
//             <div
//                 style={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(4, 1fr)",
//                     gap: "6px",
//                     padding: "10px",
//                 }}
//             >
//                 {[
//                     "7",
//                     "8",
//                     "9",
//                     "/",
//                     "4",
//                     "5",
//                     "6",
//                     "*",
//                     "1",
//                     "2",
//                     "3",
//                     "-",
//                     "0",
//                     ".",
//                     "=",
//                     "+",
//                 ].map((val, i) => (
//                     <button
//                         key={i}
//                         onClick={val === "=" ? handleCalculate : () => handleClick(val)}
//                         style={{
//                             padding: "14px",
//                             fontSize: "16px",
//                             borderRadius: "8px",
//                             border: "1px solid #ddd",
//                             cursor: "pointer",
//                             background: val === "=" ? "#0077ff" : "#f9f9f9",
//                             color: val === "=" ? "#fff" : "#000",
//                             fontWeight: val === "=" ? "bold" : "normal",
//                         }}
//                     >
//                         {val}
//                     </button>
//                 ))}
//             </div>

//             {/* Clear Button */}
//             <button
//                 onClick={handleClear}
//                 style={{
//                     width: "90%",
//                     margin: "8px auto",
//                     display: "block",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     border: "none",
//                     background: "#ff4444",
//                     color: "#fff",
//                     fontSize: "14px",
//                     cursor: "pointer",
//                 }}
//             >
//                 Clear
//             </button>
//         </div>
//     );
// };

// export default CalculatorPopup;

import React, { useRef, useState } from "react";

const CalculatorPopup = ({ onClose }) => {
    const [input, setInput] = useState("");
    const [position, setPosition] = useState({ x: 150, y: 150 });
    const [dragging, setDragging] = useState(false);
    const offset = useRef({ x: 0, y: 0 });

    const handleClick = (value) => setInput((prev) => prev + value);

    const handleCalculate = () => {
        try {
            // eslint-disable-next-line no-eval
            setInput(eval(input).toString());
        } catch {
            setInput("Error");
        }
    };

    const handleClear = () => setInput("");
    const handleBackspace = () => setInput((prev) => prev.slice(0, -1));
    const handleChange = (e) => setInput(e.target.value);
    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleCalculate();
        if (e.key === "Backspace") handleBackspace();
    };

    // Drag logic
    const handleMouseDown = (e) => {
        setDragging(true);
        offset.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        };
    };
    const handleMouseMove = (e) => {
        if (dragging) {
            setPosition({
                x: e.clientX - offset.current.x,
                y: e.clientY - offset.current.y,
            });
        }
    };
    const handleMouseUp = () => setDragging(false);

    const buttons = [
        { label: "AC", type: "action", onClick: handleClear },
        { label: "⌫", type: "action", onClick: handleBackspace },
        { label: "%", type: "operator" },
        { label: "÷", value: "/", type: "operator" },

        { label: "7", type: "number" },
        { label: "8", type: "number" },
        { label: "9", type: "number" },
        { label: "×", value: "*", type: "operator" },

        { label: "4", type: "number" },
        { label: "5", type: "number" },
        { label: "6", type: "number" },
        { label: "−", value: "-", type: "operator" },

        { label: "1", type: "number" },
        { label: "2", type: "number" },
        { label: "3", type: "number" },
        { label: "+", type: "operator" },

        { label: "0", type: "number" },
        { label: "00", type: "number" },
        { label: ".", type: "number" },
        { label: "=", type: "equal", onClick: handleCalculate },
    ];

    const getButtonStyle = (type) => {
        switch (type) {
            case "number":
                return {
                    background: "#fff",
                    color: "#000",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
                };
            case "operator":
            case "action":
                return {
                    background: "#d3d3d3",
                    color: "#000",
                };
            case "equal":
                return {
                    background: "orange",
                    color: "#fff",
                    fontWeight: "bold",
                };
            default:
                return {};
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: position.y,
                left: position.x,
                background: "#f2f2f2", // Light modern theme
                borderRadius: "16px",
                boxShadow: "0 12px 25px rgba(0,0,0,0.2)",
                width: "320px",
                zIndex: 9999,
                userSelect: "none",
                overflow: "hidden",
            }}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
        >
            {/* Header */}
            <div
                style={{
                    background: "#0077ff",
                    color: "#fff",
                    padding: "10px",
                    cursor: "move",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                onMouseDown={handleMouseDown}
            >
                <span style={{ fontWeight: "bold" }}>🔢 Calculator</span>
                <button
                    onClick={onClose}
                    style={{
                        background: "#ff4e50",
                        border: "none",
                        color: "#fff",
                        fontSize: "14px",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                    }}
                >
                    ✖
                </button>
            </div>

            {/* Display */}
            <input
                type="text"
                value={input}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                style={{
                    width: "100%",
                    padding: "18px",
                    fontSize: "24px",
                    textAlign: "right",
                    border: "none",
                    background: "#eaeaea",
                    color: "#000",
                    outline: "none",
                }}
            />

            {/* Buttons */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "12px",
                    padding: "15px",
                    background: "#f9f9f9",
                }}
            >
                {buttons.map((btn, i) => (
                    <button
                        key={i}
                        onClick={
                            btn.onClick
                                ? btn.onClick
                                : () => handleClick(btn.value || btn.label)
                        }
                        style={{
                            padding: "18px",
                            fontSize: "18px",
                            borderRadius: "10px",
                            border: "none",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            ...getButtonStyle(btn.type),
                        }}
                        onMouseEnter={(e) =>
                            (e.target.style.opacity = "0.85")
                        }
                        onMouseLeave={(e) =>
                            (e.target.style.opacity = "1")
                        }
                    >
                        {btn.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CalculatorPopup;
